import { FormFieldModel } from "../typings";
import { locKeys } from "../components/l10n";

interface SearchFormProps {
  [key: string]: FormFieldModel;
}

export const SearchForm: SearchFormProps = {
  HotelOnly: {
    formFieldName: "destination",
    formFieldLabel: locKeys.hotelDestinationFieldLabel,
    formFieldStid: "hotel-destination",
    typeaheadLob: "HOTELS",
    typeaheadPlaceholder: locKeys.typeaheadPlaceholder,
  },
  HotelCar: {
    formFieldName: "destination",
    formFieldLabel: locKeys.hotelDestinationFieldLabel,
    formFieldStid: "hotel-destination",
    typeaheadLob: "HOTELS",
    typeaheadPlaceholder: locKeys.typeaheadPlaceholder,
    packageType: "hc",
  },
  HotelFlight: {
    formFieldName: "fh-origin",
    formFieldLabel: locKeys.flightOriginFieldLabel,
    formFieldStid: "fh-origin",
    typeaheadLob: "FLIGHTS",
    typeaheadPlaceholder: locKeys.typeaheadPlaceholder,
    packageType: "fh",
    directFlightEnabled: true,
  },
  HotelFlightCar: {
    formFieldName: "fhc-origin",
    formFieldLabel: locKeys.flightOriginFieldLabel,
    formFieldStid: "fh-destination",
    typeaheadLob: "FLIGHTS",
    typeaheadPlaceholder: locKeys.typeaheadPlaceholder,
    packageType: "fhc",
    directFlightEnabled: true,
  },
};
